<template>
  <div class="app-container">
    <!-- Logo 区域 -->
    <div class="logo-section">
      <img
        src="https://www.onechannel.one/wp-content/uploads/2022/05/one-channel-logo-1-1.png"
        alt="One Channel"
        class="logo-img"
      >
    </div>

    <!-- 主卡片 -->
    <div class="card-panel">

      <!-- 警告框 (完全参考图片样式) -->
      <div class="warning-box">
        <div class="warning-header">
          <svg class="warn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <span class="warn-title">SECURITY WARNING</span>
        </div>
        <p class="warn-desc">
          Code is for login verification only.<br>
          <span class="highlight-red">Do not use for other purposes.</span>
        </p>
      </div>

      <!-- 内容切换区域 -->
      <div class="content-body">

        <!-- 状态1: 初始 & 加载中 -->
        <div v-if="!otpCode && !errorMessage">
          <p class="instruction-text">Click below to retrieve your verification code.</p>

          <button
            class="action-btn"
            :disabled="isLoading"
            @click="fetchOtp"
          >
            <!-- Loading 状态 -->
            <span v-if="isLoading" class="loader-wrapper">
              <svg class="spinner" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
              </svg>
              Fetching...
            </span>

            <!-- 正常状态 -->
            <span v-else class="btn-content">
              <svg class="lock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              Get Code
            </span>
          </button>
        </div>

        <!-- 状态2: 成功获取 Code -->
        <div v-if="otpCode" class="result-area fade-in">
          <p class="instruction-text">YOUR ONE-TIME CODE</p>
          <div class="code-display" title="Click to Copy" @click="copyToClipboard">
            {{ otpCode }}
          </div>
          <p class="copy-hint" :class="{show: showCopyHint}">Copied to clipboard</p>
        </div>

        <!-- 状态3: 错误信息 -->
        <div v-if="errorMessage" class="error-area fade-in">
          <p class="error-text">{{ errorMessage }}</p>
          <!-- <button class="retry-btn" @click="resetState">Try Again</button> -->
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'OtpGet',
  data() {
    return {
      isLoading: false,
      otpCode: null,
      errorMessage: null,
      qParam: '',
      showCopyHint: false
    }
  },
  mounted() {
    // 获取 URL query 参数 'q'
    this.qParam = this.getQueryParam('q')
  },
  methods: {
    getQueryParam(name) {
      return this.$route.query.q
    },

    resetState() {
      this.errorMessage = null
      this.isLoading = false
    },

    copyToClipboard() {
      if (!this.otpCode) return
      const el = document.createElement('textarea')
      el.value = this.otpCode
      document.body.appendChild(el)
      el.select()
      navigator.clipboard.writeText(el.value)
      document.body.removeChild(el)

      this.showCopyHint = true
      setTimeout(() => { this.showCopyHint = false }, 2000)
    },

    fetchOtp() {
      if (!this.qParam) {
        this.errorMessage = "Missing 'q' parameter in URL."
        return
      }

      this.isLoading = true

      fetch(`/srv/api/appconfig/query_email_code?q=${encodeURIComponent(this.qParam)}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok')
          return res.json()
        })
        .then(data => {
        // 根据需求: 如果 data.code 存在则显示，否则显示 message
          if (data && data.data && data.data.code) {
          // 为了演示动画效果，这里可以加一个小延迟，生产环境可去掉
            setTimeout(() => {
              this.otpCode = data.data.code
              this.isLoading = false
            }, 500)
          } else {
            this.errorMessage = data.message || 'Code retrieval failed.'
            this.isLoading = false
          }
        })
        .catch(err => {
          console.error(err)
          this.errorMessage = 'Connection failed. Please try again.'
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
/* reset & base */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.app-container {
  min-height: 100vh;
  width: 100%;
  background-color: #000000; /* 纯黑背景 */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #ffffff;
}

/* Logo Section */
.logo-section {
  margin-bottom: 30px;
}

.logo-img {
  height: 60px; /* 调整Logo大小以匹配图片比例 */
  width: auto;
  object-fit: contain;
}

/* Card Panel */
.card-panel {
  width: 100%;
  max-width: 400px;
  background-color: #0a0b10; /* 极深的灰蓝色，接近黑色 */
  border: 1px solid #1f2128;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.8);
  margin-bottom: 40px;
}

/* Warning Box - 复刻图片样式 */
.warning-box {
  background: rgba(60, 20, 20, 0.5); /* 深红色半透明背景 */
  border: 1px solid rgba(255, 83, 83, 0.15);
  border-left: 4px solid #ff536b; /* 左侧亮红色边框 */
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 24px;
}

.warning-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.warn-icon {
  width: 18px;
  height: 18px;
  color: #ff536b;
  margin-right: 8px;
}

.warn-title {
  color: #ff536b;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.5px;
}

.warn-desc {
  color: #e0e0e0;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5;
}

.highlight-red {
  color: #ff536b;
  text-decoration: underline; /* 图片中有下划线效果 */
  text-decoration-color: rgba(255, 83, 107, 0.6);
  font-weight: bold;
}

/* Content Body */
.content-body {
  text-align: center;
  min-height: 100px; /* 防止高度塌陷抖动 */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.instruction-text {
  color: #8a8d95;
  font-size: 14px;
  margin-bottom: 16px;
}

/* Button Styling - 复刻图片中的紫色/洋红渐变 */
.action-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #d036e8 0%, #ff53f8 100%); /* 渐变色 */
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 15px rgba(213, 54, 232, 0.3); /* 按钮发光效果 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(213, 54, 232, 0.5);
}

.action-btn:disabled {
  opacity: 0.8;
  cursor: wait;
}

.btn-content {
  display: flex;
  align-items: center;
}

.lock-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-bottom: 2px;
}

/* Result Area */
.result-area {
  margin-top: 10px;
}

.code-display {
  font-size: 36px;
  font-weight: bold;
  color: #ff53f8;
  letter-spacing: 4px;
  padding: 10px;
  background: rgba(255, 83, 248, 0.05);
  border-radius: 8px;
  border: 1px dashed rgba(255, 83, 248, 0.3);
  cursor: pointer;
  transition: background 0.3s;
}

.code-display:hover {
  background: rgba(255, 83, 248, 0.1);
}

.copy-hint {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}

.copy-hint.show {
  opacity: 1;
}

/* Error Area */
.error-text {
  color: #ff536b;
  margin-bottom: 10px;
}

.retry-btn {
  background: transparent;
  border: 1px solid #444;
  color: #aaa;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.retry-btn:hover {
  border-color: #ff53f8;
  color: #ff53f8;
}

/* Footer */
.footer-text {
  color: #3a3d45; /* 很暗的灰色，如图片所示 */
  font-size: 12px;
  margin-top: 20px;
}

/* Spinner Animation */
.loader-wrapper {
  display: flex;
  align-items: center;
}
.spinner {
  animation: rotate 2s linear infinite;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.spinner .path {
  stroke: #ffffff;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% { transform: rotate(360deg); }
}
@keyframes dash {
  0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
  50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
  100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
}

/* Fade In Animation */
.fade-in {
  animation: fadeIn 0.5s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
